<div class="chart-wrapper">
  <div class="chart-content">
    @for (item of data; track item) {
      <div
        class="bar"
        [style.background-color]="item.color"
        [style.height]="item.height"
        [style.width.px]="barWidth"
        [style.margin-right.px]="barGap"
        [style.margin-left.px]="barGap"
        [matTooltip]="item.time">
      </div>
    }
    <div class="chart-line line1"></div>
    <div class="chart-line line2"></div>
    <div class="chart-line line3"></div>
  </div>

  <span class="label-on">ON</span>
  <span class="label-off">OFF</span>

  @if (showLabel) {
    <div class="legends">
      @for (item of data; track item) {
        <span>{{item.time}}</span>
      }
    </div>
  }
</div>
